<template>
  <div :class="classObj" class="app-wrapper">
    <div class="fixed-header-container">
      <navbar @forgetPassword="popUp" />
    </div>

    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <sidebar class="sidebar-container" />

    <div :class="{hasTagsView:needTagsView}" class="main-container">
      <div :class="{'fixed-header':fixedHeader}">
        <!-- <navbar /> -->
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
      <right-panel v-if="showSettings">
        <settings />
      </right-panel>
    </div>

    <!-- <div class="fixed-footer-container">
      <div class="footer-text">
        <span>Copyright©港中旅华贸国际物流股份有限公司</span>
        <span>技术支持：吉联新软件股份有限公司</span>
      </div>
    </div> -->

    <!-- label="新密码" -->
   <div class="change-password-dialog">
    <el-dialog title="修改密码" width="26%" :visible.sync="dialogFormVisible" @close="clearvalue('ruleForm')" >
      <!-- <div class="changePasswordTitle">修改密码</div> -->
      <div>当前用户：{{userNameCn}} </div>
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <div prop="oldPwd" class="change-password-item">
            <span class="asterisk">*</span><span>旧密码：</span>
          <el-input type="password" v-model="ruleForm.oldPwd" autocomplete="off"></el-input>
        </div>
        <div prop="newPwd" class="change-password-item">
         <span class="asterisk">*</span> <span>新密码：</span>
          <el-input type="password" v-model="ruleForm.newPwd" autocomplete="off"></el-input>
        </div>
        <div prop="confiPwd" class="change-password-item">
          <span class="asterisk">*</span><span>确认密码：</span>
          <el-input type="password" v-model="ruleForm.confiPwd" autocomplete="off"></el-input>
        </div>
        <div class="prompt">提示：密码必须包含大写字母、小写字母、数字或特殊符号,长度必须在8到30之间 </div>
         <!--  <el-form-item class="btns">
              <el-button type="primary" @click="queren(ruleForm)">确定</el-button>
              <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item> -->
        <div class="change-password-btns">
              <el-button class="btn el-button-search" type="primary" @click="queren(ruleForm)">确定</el-button>
              <el-button class="btn" type="primary" plain @click="resetForm('ruleForm')">取消</el-button>
         </div>
      </el-form>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import RightPanel from '@/components/RightPanel'
import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState } from 'vuex'
import { modifyPwdSysUser } from '@/api/system'

export default {
  data(){
    var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('旧密码不能为空'));
        }
        callback();
      };
    var validatePass1 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
            let validatePass1 = value.match(/((?=.*[A-Z])(?=.*[a-z])((?=.*[^a-zA-Z0-9])|(?=.*[0-9]))).{6,30}$/)
            if(!validatePass1) {
              callback(new Error('密码必须包含大写字母、小写字母、数字或特殊符号,长度必须在8到30之间'));
            } else {
           callback();
            }
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.newPwd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
    return {
      dialogFormVisible: false,
      ruleForm: {
          appCode: '',
          oldPwd: '',
          newPwd: '',
          confiPwd: '',
          userName: ''
      },
      rules: {
          oldPwd: [
            { validator: validatePass , trigger: 'blur' }
            ],
          newPwd: [
            { validator: validatePass1, trigger: 'blur' }
          ],
          confiPwd: [
            { validator: validatePass2, trigger: 'blur' }
          ],
        },
        userInfo: {},
        userNameCn: ''

    }
  },
   mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
     this.userNameCn=this.userInfo.userNameCn
     this.ruleForm.userName=this.userInfo.username
        },
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    RightPanel,
    Settings,
    Sidebar,
    TagsView
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      showSettings: state => state.settings.showSettings,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile',
        'in-iframe': !!this.$route.query.inIframe,
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
    popUp(data){
      this.dialogFormVisible=data
    },
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.dialogFormVisible=false
      },
      queren(data){
        let self=this
        modifyPwdSysUser(data).then(res => {
          if(res.status===0) {
             self.$coreMethods.message(
              "warning","密码修改成功");
              this.dialogFormVisible=false
          } else  {
             self.$coreMethods.message(
              "warning","旧密码输入不正确，请重新输入");
          }
        }).catch(error => {
          console.log(error)
        })
      },
      clearvalue(formName){
        this.$refs[formName].resetFields();
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    min-width: 1200px;

    // iframe 布局下隐藏侧边栏等
    &.in-iframe::v-deep {
      font-size: 12px;
      .hamburger-container,
      .right-menu,
      .fixed-header-container,
      .fixed-header,
      .sidebar-container,
      .sidebar-logo-container {
        display: none !important;
      }
      .fixed-header {
        left: 10px;
        right: 10px;
        width: auto;
      }
      .main-container {
        margin-left: 0 !important;
        .app-main {
          padding-top: 0;
        }
      }
    }

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    // top: 50px;
    top: 15px;
    // right: 0;
    left: 190px;
    z-index: 1002;
    // width: calc(100% - #{$sideBarWidth});
    width: calc(100% - 450px);
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    // width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
  .fixed-header-container {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 1001;
    width: 100%;
  }
  .fixed-footer-container {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 1001;
    width: 100%;
    height: 50px;
    text-align: center;
    background-color: #353535;
    .footer-text {
      display: flex;
      flex-flow: column;
      font-size: 12px;
      color: #ffffff;
      line-height: 16px;
      margin-top: 10px;
    }
  }
  .prompt{
    color: red;
    margin-top: 10px;
  }
.asterisk{
  color: red;
}
.btns{
  float: right;
  padding-bottom: 20px;
}
.changePasswordTitle{
  text-align: center;
  font-size: 24px;
}
</style>
